import React, { useState, useContext } from 'react';
import { AppContext } from '../context/AppContext';

const AnggotaForm = ({ initialData, onCancel, onSaveComplete }) => {
  const { tambahAnggota, editAnggota, kelasMeta } = useContext(AppContext);
  const [form, setForm] = useState(initialData || {
    nama: '',
    jumlah_anak: 1,
    kelas: kelasMeta?.kelas || '',
    kode_kelas: kelasMeta?.kode_kelas || '',
    pembina: kelasMeta?.pembina || '',
    bendahara: kelasMeta?.bendahara || '',
    penyetor: kelasMeta?.penyetor || '',
  });

  const needMetadata = !initialData && !kelasMeta?.isComplete;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      nama: form.nama.trim(),
      jumlah_anak: Number(form.jumlah_anak),
    };

    if (needMetadata) {
      data.kelas = form.kelas;
      data.kode_kelas = form.kode_kelas.trim();
      data.pembina = form.pembina.trim();
      data.bendahara = form.bendahara.trim();
      data.penyetor = form.penyetor.trim();
    }

    if (initialData && initialData.id) {
      await editAnggota(initialData.id, data);
      if (onSaveComplete) onSaveComplete();
    } else {
      await tambahAnggota(data);
      setForm((prev) => ({ ...prev, nama: '', jumlah_anak: 1 }));
    }
    if (onCancel) onCancel();
  };

  return (
    <form onSubmit={handleSubmit} className="bg-gray-100 p-4 rounded shadow mb-4">
      <h3 className="font-bold mb-2">{initialData ? 'Edit Anggota' : 'Tambah Anggota'}</h3>
      <div className="grid gap-2">
        <div>
          <label className="block text-sm font-medium mb-1">Nama Lengkap</label>
          <input
            type="text"
            placeholder="Contoh: Anwari"
            value={form.nama}
            onChange={e => setForm({ ...form, nama: e.target.value })}
            className="border p-2 rounded w-full"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Jumlah Anak</label>
          <input
            type="number"
            placeholder="Jumlah anak"
            value={form.jumlah_anak}
            onChange={e => setForm({ ...form, jumlah_anak: e.target.value })}
            className="border p-2 rounded w-full"
            required
            min="0"
          />
        </div>
        {needMetadata && (
          <>
            <div>
              <label className="block text-sm font-medium mb-1">Kelas</label>
              <select
                value={form.kelas}
                onChange={e => setForm({ ...form, kelas: e.target.value })}
                className="border p-2 rounded w-full"
                required
              >
                <option value="">-- Pilih Kelas --</option>
                <option value="AI">AI</option>
                <option value="AA">AA</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Kode Kelas</label>
              <input
                type="text"
                value={form.kode_kelas}
                onChange={e => setForm({ ...form, kode_kelas: e.target.value })}
                className="border p-2 rounded w-full"
                placeholder="Contoh: 404A"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Pembina</label>
              <input
                type="text"
                value={form.pembina}
                onChange={e => setForm({ ...form, pembina: e.target.value })}
                className="border p-2 rounded w-full"
                placeholder="Nama pembina"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Bendahara</label>
              <input
                type="text"
                value={form.bendahara}
                onChange={e => setForm({ ...form, bendahara: e.target.value })}
                className="border p-2 rounded w-full"
                placeholder="Nama bendahara"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Penyetor</label>
              <input
                type="text"
                value={form.penyetor}
                onChange={e => setForm({ ...form, penyetor: e.target.value })}
                className="border p-2 rounded w-full"
                placeholder="Nama penyetor"
                required
              />
            </div>
          </>
        )}
        <div className="flex gap-2 mt-2">
          <button type="submit" className="bg-blue-600 text-white p-2 rounded">
            {initialData ? 'Simpan' : 'Tambah'}
          </button>
          {onCancel && <button type="button" onClick={onCancel} className="bg-gray-400 p-2 rounded">Batal</button>}
        </div>
      </div>
    </form>
  );
};

export default AnggotaForm;